<template>
  <div id="login_page">
    <div class="formContainer flex-mid fc-FFFFFF">
      <div class="divContainer2">
        <div class="form-content">
          <el-form
            :model="ruleForm2"
            status-icon
            ref="ruleForm2"
            class="demo-ruleForm"
          >
            <div class="center">
              <img
                src="../assets/images/navbar/logo_happily_dark.png"
                class="imgLogo"
                alt="Happily.ai Logo"
              />
            </div>
            <div class="welcome-text">
              <template v-if="isAddingAccount">
                Add Another Account
              </template>
              <template v-else>
                {{ $t('login.sign_in_to') }} <span class="brand-highlight">MyHappily</span>
              </template>
            </div>
            <div class="subtitle">
              <template v-if="isAddingAccount">
                Sign in with a different + email to add another workspace
              </template>
              <template v-else>
                {{ $t('login.please_enter_your') }}
              </template>
            </div>
            
            <!-- Show existing accounts when adding a new one -->
            <div v-if="isAddingAccount && existingAccounts.length > 0" class="existing-accounts">
              <div class="existing-accounts-label">Your accounts:</div>
              <div class="existing-accounts-list">
                <div 
                  v-for="account in existingAccounts" 
                  :key="account.email"
                  class="existing-account-item"
                  @click="switchToAccount(account)"
                >
                  <div class="account-avatar" :style="{ backgroundColor: account.color }">
                    {{ account.initials }}
                  </div>
                  <div class="account-info">
                    <div class="account-name">{{ account.companyName }}</div>
                    <div class="account-email">{{ account.email }}</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-section">
              <el-form @submit.prevent.native>
                <el-form-item
                  prop="email"
                  class="formItem"
                >
                  <div class="input-wrapper">
                    <el-input
                      class="input-email"
                      type="email"
                      ref="email_input"
                      v-model="ruleForm2.emailinput"
                      @keyup.enter.native="submitForm"
                      placeholder="Email address"
                      auto-complete="off"
                    ></el-input>
                  </div>
                  <div class="checkbox-section">
                    <el-checkbox v-model="ruleForm2.checked" class="keep-logged-checkbox">
                      <span class="checkbox-label">{{ $t('login.keep_me_logged') }}</span>
                    </el-checkbox>
                  </div>
                  <div class="terms-section">
                    <span class="terms-text">I agree to the </span>
                    <a target="window" href="https://happily.ai/terms" class="terms-link">
                      {{ $t('login.terms_and_Conditions') }}
                    </a>
                  </div>
                  <el-button
                    :disabled="disable"
                    :loading="loading"
                    class="btnSignIn"
                    type="primary"
                    @click="submitForm"
                    >{{ loading ? 'Signing in...' : $t('login.sign_in') }}</el-button
                  >
                </el-form-item>
              </el-form>
            </div>
          </el-form>
        </div>
        <div v-if="errorip" class="error-section">
          <div class="error-title">
            {{ $t('login.your_account_access') }}
          </div>
          <div class="error-ip">({{ $t('login.your_IP') }}: {{ errorip }})</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "firebase/app";
import "firebase/auth";
export default {
  created() {
    // Don't redirect if we're adding a new account
    const isAddingAccount = localStorage.getItem('addingAccount') === 'true';
    
    if (!isAddingAccount && firebase.auth().currentUser && localStorage.getItem("userData")) {
      this.$router.push({ name: "insights" }); // insights
    } else if (!isAddingAccount) {
      localStorage.removeItem("userData");
    }
  },
  computed: {
    user() {
      return this.$store.getters["authen/user"];
    },
    error() {
      return this.$store.getters["authen/error"];
    },
    loading() {
      return this.$store.getters["authen/loading"];
    },
    errorip() {
      return this.$store.getters["authen/errorip"];
    },
    isAddingAccount() {
      return localStorage.getItem('addingAccount') === 'true';
    },
    existingAccounts() {
      return this.$store.getters['accountSwitcher/sortedAccounts'] || [];
    },
  },
  watch: {
    error: function (val) {
      this.showError(val);
    },
    loading(newVal) {
      // เมื่อ loading เสร็จ (false) ให้ enable ปุ่มกลับ
      if (!newVal) {
        this.disable = false;
      }
    }
  },
  data() {
    return {
      ruleForm2: {
        emailinput: "",
        checked: true,
      },
      disable: false,
    };
  },
  mounted() {
    this.$refs.email_input.select()
  },
  methods: {
    async switchToAccount(account) {
      // Clear the adding account flag and switch to selected account
      localStorage.removeItem('addingAccount');
      try {
        await this.$store.dispatch('accountSwitcher/switchAccount', account.email);
      } catch (error) {
        this.$message({
          type: 'error',
          message: error.message || 'Failed to switch account',
        });
      }
    },
    submitForm() {
      // Clear adding account flag on successful submission
      // (the flag will be cleared after login completes)
      
      // ป้องกันการกดซ้ำ
      if (this.disable || this.loading) {
        return;
      }

      if (!this.ruleForm2.emailinput) {
        this.$message({
          showClose: true,
          message: "Email required.",
          type: "error",
        });
      } else if (!this.validEmail(this.ruleForm2.emailinput)) {
        this.$message({
          showClose: true,
          message: "Valid email required.",
          type: "error",
        });
      } else {
        this.disable = true;
        this.auth();
      }
    },
    auth() {
      this.$store.dispatch("auth/login", {
        email: this.ruleForm2.emailinput,
      });
    },
    showError(message) {
      if (message) {
        this.$message({
          showClose: true,
          message,
          type: "error",
        });
        setTimeout(() => {
          this.$store.dispatch("authen/clearError");
        }, 1000);
      }
    },
    validEmail: function (email) {
      var re =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
  },
};
</script>

<style lang="scss" scoped>
.formContainer {
  min-height: 100vh;
  height: calc(100vh);
  background: linear-gradient(135deg, #6c30cc 0%, #5a28b8 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.divContainer2 {
  width: 100%;
  max-width: 480px;
  background: rgba(17, 17, 17, 0.15);
  backdrop-filter: blur(10px);
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  transition: all 0.3s ease;
  border: 1px solid rgba(255, 255, 255, 0.1);
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 12px 40px rgba(0, 0, 0, 0.4);
  }
}

.form-content {
  padding: 48px 40px 32px 40px;
  
  @media (max-width: 768px) {
    padding: 32px 24px 24px 24px;
  }
}

.imgLogo {
  height: 64px;
  width: auto;
  margin-bottom: 16px;
  filter: drop-shadow(0 2px 8px rgba(0, 0, 0, 0.2));
}

.welcome-text {
  font-size: 28px;
  font-weight: 800;
  margin-top: 32px;
  margin-bottom: 8px;
  text-align: center;
  color: #ffffff;
  line-height: 1.2;
  
  @media (max-width: 768px) {
    font-size: 24px;
    margin-top: 24px;
  }
}

.brand-highlight {
  color: #FBC02D;
  background: linear-gradient(45deg, #FBC02D, #FFD54F);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.subtitle {
  font-size: 16px;
  color: rgba(255, 255, 255, 0.8);
  text-align: center;
  margin-bottom: 32px;
  line-height: 1.4;
}

.form-section {
  margin-top: 24px;
}

.formItem {
  width: 100%;
}

.input-wrapper {
  margin-bottom: 20px;
}

.input-email {
  height: 48px;
  font-size: 16px;
  border-radius: 8px;
  
  &:deep(.el-input__inner) {
    border-radius: 8px;
    height: 48px;
    font-size: 16px;
    padding: 0 16px;
  }
}

.checkbox-section {
  margin-bottom: 24px;
}

.keep-logged-checkbox {
  &:deep(.el-checkbox__label) {
    color: #ffffff;
    font-size: 14px;
  }
  
  &:deep(.el-checkbox__input.is-checked .el-checkbox__inner) {
    background-color: #32C2D5;
    border-color: #32C2D5;
  }
  
  &:deep(.el-checkbox__inner) {
    border-color: rgba(255, 255, 255, 0.3);
    background-color: transparent;
  }
}

.checkbox-label {
  color: rgba(255, 255, 255, 0.9);
  font-size: 14px;
  margin-left: 8px;
}

.terms-section {
  margin-bottom: 32px;
  font-size: 14px;
  text-align: center;
  color: rgba(255, 255, 255, 0.7);
}

.terms-text {
  color: rgba(255, 255, 255, 0.7);
}

.terms-link {
  color: #32c2d5;
  text-decoration: none;
  font-weight: 500;
  transition: color 0.2s ease;
  
  &:hover {
    color: #28a8b8;
    text-decoration: underline;
  }
}

.btnSignIn {
  width: 100%;
  height: 52px;
  font-size: 18px;
  font-weight: 700;
  background: linear-gradient(135deg, #32C2D5 0%, #28a8b8 100%);
  border: none;
  border-radius: 8px;
  transition: all 0.3s ease;
  box-shadow: 0 4px 16px rgba(50, 194, 213, 0.3);
  
  &:hover:not(:disabled) {
    transform: translateY(-1px);
    box-shadow: 0 6px 20px rgba(50, 194, 213, 0.4);
    background: linear-gradient(135deg, #28a8b8 0%, #32C2D5 100%);
  }
  
  &:active:not(:disabled) {
    transform: translateY(0);
  }
  
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
    box-shadow: 0 2px 8px rgba(50, 194, 213, 0.2);
  }
}

.error-section {
  margin: 24px 32px 32px 32px;
  padding: 20px 24px;
  border-radius: 8px;
  background: linear-gradient(135deg, #F44336 0%, #d32f2f 100%);
  color: #ffffff;
  text-align: center;
  font-size: 14px;
  box-shadow: 0 4px 16px rgba(244, 67, 54, 0.3);
  
  @media (max-width: 768px) {
    margin: 16px 24px 24px 24px;
    padding: 16px 20px;
  }
}

.error-title {
  font-weight: 700;
  margin-bottom: 4px;
}

.error-ip {
  opacity: 0.9;
  font-size: 13px;
}

/* Existing accounts section for multi-account users */
.existing-accounts {
  margin-top: 20px;
  padding: 16px;
  background: rgba(0, 0, 0, 0.15);
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.existing-accounts-label {
  font-size: 12px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.7);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 12px;
}

.existing-accounts-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.existing-account-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 12px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover {
    background: rgba(255, 255, 255, 0.15);
    transform: translateX(4px);
  }
}

.existing-account-item .account-avatar {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 700;
  color: #ffffff;
  flex-shrink: 0;
}

.existing-account-item .account-info {
  flex: 1;
  min-width: 0;
}

.existing-account-item .account-name {
  font-size: 14px;
  font-weight: 600;
  color: #ffffff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.existing-account-item .account-email {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.6);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>

<style lang="scss">
#login_page {
  ::placeholder {
    color: rgba(255, 255, 255, 0.6);
    opacity: 1;
  }
  
  .el-input__inner {
    background-color: rgba(255, 255, 255, 0.1);
    border: 2px solid rgba(255, 255, 255, 0.2);
    transition: all 0.3s ease;
    color: #ffffff;
    border-radius: 8px;
    
    &:focus {
      color: #ffffff;
      border-color: #32C2D5;
      background-color: rgba(0, 0, 0, 0.2);
      box-shadow: 0 0 0 3px rgba(50, 194, 213, 0.1);
      outline: none;
    }
    
    &:hover:not(:focus) {
      border-color: rgba(255, 255, 255, 0.3);
      background-color: rgba(0, 0, 0, 0.15);
    }
  }
  
  .el-checkbox__inner {
    background-color: transparent;
    border-color: rgba(255, 255, 255, 0.3);
    
    &:hover {
      border-color: #32C2D5;
    }
  }
  
  .el-checkbox__input.is-checked .el-checkbox__inner {
    background-color: #32C2D5;
    border-color: #32C2D5;
    
    &::after {
      border-color: #ffffff;
    }
  }
  
}
</style>